import { PERMISSIONS } from "@/shared/config/permissions";

/**
 * Permissões que indicam GESTÃO de predefinições (nomes de etapas/atividades),
 * e não apenas leitura.
 *
 * Importante: as permissões `CAN_LIST_STEP_NAMES` / `CAN_LIST_TASK_NAMES` NÃO entram
 * aqui de propósito. Utilizadores operacionais precisam dessas permissões de leitura
 * para o autocomplete ao criar etapas/atividades, mas isso não lhes deve dar acesso
 * ao menu administrativo "Predefinições". Ver issue #1.1 (Sistema Portugal).
 */
export const PREDEFINITIONS_MANAGEMENT_PERMISSIONS = [
    PERMISSIONS.CAN_CREATE_STEP_NAME,
    PERMISSIONS.CAN_UPDATE_STEP_NAME,
    PERMISSIONS.CAN_DELETE_STEP_NAME,
    PERMISSIONS.CAN_CREATE_TASK_NAME,
    PERMISSIONS.CAN_UPDATE_TASK_NAME,
    PERMISSIONS.CAN_DELETE_TASK_NAME,
] as const;

/**
 * Retorna `true` apenas se o conjunto de permissões incluir alguma permissão de
 * GESTÃO de predefinições. Apenas listar (autocomplete) não basta.
 */
export function canManagePredefinitions(permissions: readonly string[]): boolean {
    return PREDEFINITIONS_MANAGEMENT_PERMISSIONS.some((p) => permissions.includes(p));
}
